import { createContext, use } from "react";

import type { HeadingLevelProps } from "./TypographicElements.types";
import type { FC, PropsWithChildren } from "react";

const HeadingLevelContext = createContext<number>(0);

const useHeadingLevelContext = () => use(HeadingLevelContext);
const HeadingLevel: FC<PropsWithChildren<HeadingLevelProps>> = ({ children, resetHeadingLevelTo, bumpLevelBy = 1 }) => {
	const headingLevelContext = useHeadingLevelContext();

	return (
		<HeadingLevelContext value={resetHeadingLevelTo ?? headingLevelContext + bumpLevelBy}>
			{children}
		</HeadingLevelContext>
	);
};

export const TypoGraphicElementInternals = {
	useHeadingLevelContext,
	HeadingLevel,
};
